import Vue from "vue";
import axios from "axios";
import { store } from "Store/store";
import router from "Router";
import AppConfig from "Constants/AppConfig";
import { throttleAdapterEnhancer } from "axios-extensions";
import { cacheAdapterEnhancer } from "axios-extensions";
import { retryAdapterEnhancer } from "axios-extensions";

const debug = process.env.NODE_ENV !== "production";

const throttleConfig = {
    threshold: 2000 * 2, // 4 seconds
};

const cacheConfig = {
    enabledByDefault: false,
    cacheFlag: "useCache",
};

const retryConfig = {
    retryTimes: 2, // 1 retry
};

const httpClient = axios.create({
    baseURL: AppConfig.baseApiUrl,
    timeout: 15000, // indicates, 1000ms ie. 1 second
    headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
    },
    adapter: cacheAdapterEnhancer(axios.defaults.adapter, cacheConfig),
    adapter: throttleAdapterEnhancer(axios.defaults.adapter, throttleConfig),
    adapter: retryAdapterEnhancer(axios.defaults.adapter, retryConfig),
});

const getAuthToken = () => "Bearer " + $cookies.get("token").token;

const authInterceptor = (config) => {
    config.headers["Authorization"] = getAuthToken();
    return config;
};

function decode_utf8(s) {
    return decodeURIComponent(escape(s));
}

httpClient.interceptors.request.use(authInterceptor);

// interceptor to catch errors
const errorInterceptor = (error) => {
    if (debug) console.error(error.response.status, error.message);

    //Quasar Toast Schema
    let message = {
        html: null,
        icon: "fa-warning",
        timeout: 2500,
    };

    console.log(error.response.status);

    if (typeof error !== "undefined" || typeof error.response.status !== "undefined") {
        message.html = null;

        if (
            typeof error.response.data !== "undefined" &&
            error.response.data != "undefined" &&
            typeof error.response.data.message !== "undefined" &&
            error.response.data.message != false
        ) {
            // uncaught if error.response.data undefined
            message.html = decode_utf8(error.response.data.message);
        }

        // all the error responses
        switch (error.response.status) {
            case 400:
                if (message.html.length == 0) message.html = "Bad request";
                break;

            case 401: // authentication error, logout the user
                message.html = "Invalid login credentials.";
                break;
            case 403: // authentication error, logout the user
                if (
                    !(router && router.currentRoute && router.currentRoute.params && router.currentRoute.params.redirect) &&
                    localStorage.getItem("user") !== null
                ) {
                    // if user still logged in
                    store.commit("logoutUser", {
                        redirect: router.currentRoute.fullPath,
                        locale: store.getters.selectedLocale.locale,
                    });
                } else {
                    store.commit("logoutUser");
                }
                break;
            case 404: // not found
                if (message.html.length == 0) message.html = "Oops! Record not found.";
                break;
            case 405: // permission denied
                if (message.html.length == 0) message.html = "Oops! Permission denied.";
                break;
            case 422: // validation error
                break;
            case 500: // server error
                if (message.html.length == 0) message.html = "Server Error";
                break;
            default:
                Vue.notify.error("Server Error");
        }

        //Try to Use the Response Message
        if (error.hasOwnProperty("response") && error.response.hasOwnProperty("error")) {
            if (error.response.data.hasOwnProperty("message") && error.response.data.error.length > 0) {
                if (message.html.length == 0) message.html = decode_utf8(error.response.data.error);
            }
        }
    }

    if (error.response.status !== 403 && message.html != null) {
        // VueNotifications.error({ message: message.html });
        setTimeout(function () {
            Vue.notify({
                group: "loggedIn",
                type: "error",
                text: decode_utf8(message.html),
            });
        }, 500);
    }

    //return Promise.reject(error);
};

// Interceptor for responses
const responseInterceptor = (response) => {
    if (typeof response.data.code !== "undefined" && typeof response.data.message !== "undefined" && response.data.message) {
        switch (response.status) {
            case 200:
                Vue.notify({
                    group: "loggedIn",
                    type: response.data.type,
                    text: decode_utf8(response.data.message),
                    duration: response.data.duration ? +response.data.duration : 4000,
                });
                break;
            // any other cases
            default:
            // default case
        }
    }

    return response;
};

httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export default httpClient;
